import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { fetchPostData, fetchPostDataNibrs } from '@/Components/hooks/Api';
import { base64ToString, Decrypt_Id_Name } from '@/Components/Common/Utility';
import { useSelector } from 'react-redux';
import { useQuery } from 'react-query';
import { useLocation } from 'react-router-dom';
import NibrsServices from '@/CADServices/APIs/nibrs';

const NIBRSContext = createContext();

export const NIBRSProvider = ({ children }) => {

  //NIBRS NEW LOGIC
  const location = useLocation();
  const query = useMemo(() => new URLSearchParams(location.search), [location.search]);
  let IncID = query?.get('IncId');
  if (!IncID) IncID = 0;
  else IncID = parseInt(base64ToString(IncID), 10);

  const [nibrsErrorId, setNibrsErrorId] = useState(null);

  const [incidentErrorStatus, setIncidentErrorStatus] = useState(false);
  const [incidentValidateNibrsData, setIncidentValidateNibrsData] = useState([]);
  const [offenseErrorStatus, setOffenseErrorStatus] = useState(false);
  const [offenseValidateNibrsData, setOffenseValidateNibrsData] = useState([]);
  const [nameErrorStatus, setNameErrorStatus] = useState(false);
  const [victimValidateNibrsData, setVictimValidateNibrsData] = useState([]);
  const [offenderValidateNibrsData, setOffenderValidateNibrsData] = useState([]);
  const [NameRelationshipError, setNameRelationshipError] = useState(false);
  const [narrativeApprovedStatus, setNarrativeApprovedStatus] = useState(false);
  const [PropErrorStatus, setPropErrorStatus] = useState(false);
  const [propertyValidateNibrsData, setPropertyValidateNibrsData] = useState([]);
  const [nibrsSideBarLoading, setNibrsSideBarLoading] = useState(false);
  const [nibrsNameValidateArray, setNibrsNameValidateArray] = useState([]);
  const [vehErrorStatus, setVehErrorStatus] = useState(false);
  const localStoreData = useSelector((state) => state.Agency.localStoreData);
  const loginPinID = localStoreData?.PINID || '';

  const getUniqueId = () =>
    sessionStorage.getItem('UniqueUserID')
      ? Decrypt_Id_Name(sessionStorage.getItem('UniqueUserID'), 'UForUniqueUserID')
      : '';

  const TXIBRSValidateCall = async (incidentID, reportDate, baseDate, oriNumber, loginAgencyID) => {
    try {
      const val = {
        gIntAgencyID: loginAgencyID,
        gIncidentID: incidentID,
        dtpDateTo: reportDate,
        dtpDateFrom: reportDate,
        BaseDate: baseDate,
        strORINumber: oriNumber,
        strComputerName: getUniqueId(),
        rdbSubmissionFile: false,
        rdbErrorLog: false,
        rdbNonReportable: false,
        chkPastErrorPrint: false,
        rdbOne: false,
        rdbTwoMonth: false,
        rdbThreeMonth: false,
        rdbAllLogFile: false,
        IPAddress: '',
        IsIncidentCheck: true,
      };
      await fetchPostData('NIBRS/TXIBRS', val);
      return true;
    } catch {
      return true;
    }
  };

  const sent_NibrsErrorStatus = (incidentID, loginAgencyID, status) => {
    fetchPostData('Incident/Update_IsNIBRSError', {
      IsNIBRSError: status,
      ModifiedByUserFK: loginPinID,
      IncidentID: incidentID,
      AgencyId: loginAgencyID,
    });
  };

  const validate_IncSideBar = async (incidentID, incidentNumber, loginAgencyID) => {
    setNibrsSideBarLoading(true);
    await TXIBRSValidateCall(incidentID, 0, 0, 0, loginAgencyID);

    const [incidentError, offenseError, victimError, offenderError, dashStatus, propertyError] = await Promise.all([
      fetchPostDataNibrs('NIBRS/GetIncidentNIBRSError', { StrIncidentID: incidentID, StrIncidentNumber: incidentNumber, StrAgencyID: loginAgencyID }),
      fetchPostDataNibrs('NIBRS/Nibrs_OffenseError', { gIncidentID: incidentID, IncidentNumber: incidentNumber, CrimeId: 0, gIntAgencyID: loginAgencyID }),
      fetchPostDataNibrs('NIBRS/GetVictimNIBRSError', { gIncidentID: incidentID, IncidentNumber: incidentNumber, NameID: 0, gIntAgencyID: loginAgencyID }),
      fetchPostDataNibrs('NIBRS/GetOffenderNIBRSError', { gIncidentID: incidentID, IncidentNumber: incidentNumber, NameID: 0, gIntAgencyID: loginAgencyID }),
      fetchPostData('DashBoard/GetData_DashBoardIncidentStatus', { IncidentID: incidentID }),
      fetchPostDataNibrs('NIBRS/GetPropertyNIBRSError', { gIncidentID: incidentID, IncidentNumber: incidentNumber, PropertyId: 0, gIntAgencyID: loginAgencyID }),
    ]);

    setIncidentErrorStatus(!!incidentError?.Administrative);
    if (incidentError?.Administrative) setIncidentValidateNibrsData(incidentError);

    const offenseObj = offenseError?.Offense || [];
    setOffenseErrorStatus(offenseObj.length > 0);
    if (offenseError) setOffenseValidateNibrsData(offenseError);

    const victimObj = victimError?.Victim || [];
    const offenderObj = offenderError?.Offender || [];
    setVictimValidateNibrsData(victimError);
    setOffenderValidateNibrsData(offenderError);
    if (victimObj.length > 0 || offenderObj.length > 0) {
      setNameErrorStatus(true);
      setNibrsNameValidateArray([...victimObj, ...offenderObj]);
    } else {
      setNameErrorStatus(false);
      setNibrsNameValidateArray([]);
    }

    if (dashStatus?.length > 0) {
      setNameRelationshipError(dashStatus[0]?.NameRelationship > 0);
      setNarrativeApprovedStatus(dashStatus[0]?.Narrative > 0);
    } else {
      setNameRelationshipError(false);
      setNarrativeApprovedStatus(false);
    }

    if (propertyError) {
      const proObj = propertyError?.Properties || [];
      const allNull = proObj.every((item) => item === null || item === undefined);
      if (allNull) {
        setPropertyValidateNibrsData([]);
        setPropErrorStatus(false);
        setVehErrorStatus(false);
      } else {
        setPropertyValidateNibrsData(propertyError);
        const firstErr = proObj[0]?.OnPageError || '';
        const hasSpecialError =
          firstErr.includes('Property must be present.') ||
          firstErr.includes('Add at least one suspected drug type') ||
          firstErr.includes('{074}');
        const VehArr = proObj.filter((item) => item?.PropertyType === 'V');
        const PropArr = proObj.filter((item) => item?.PropertyType && item?.PropertyType !== 'V');
        setPropErrorStatus(PropArr.length > 0 || VehArr.length > 0 || hasSpecialError);
        setVehErrorStatus(VehArr.length > 0 && !VehArr.every((item) => item === null || item === undefined));
      }
    } else {
      setPropErrorStatus(false);
      setVehErrorStatus(false);
    }

    setNibrsSideBarLoading(false);
    sent_NibrsErrorStatus(incidentID, loginAgencyID, incidentErrorStatus || offenseErrorStatus || nameErrorStatus || PropErrorStatus);
  };


  //NIBRS NEW LOGIC


  const getNIBRSErrorIdKey = `/NIBRS/GetNIBRSErrorId/${IncID}`;
  const {
    data: nibrsErrorIdResponse,
    isSuccess: isNibrsErrorIdSuccess,
    refetch: refetchNibrsErrorId,
  } = useQuery(
    [getNIBRSErrorIdKey, { IncidentId: IncID, state: 'TX' }],
    NibrsServices.getNIBRSErrorId,
    {
      refetchOnWindowFocus: false,
      enabled: !!IncID,
      retry: 0,
    }
  );

  useEffect(() => {
    if (nibrsErrorIdResponse && isNibrsErrorIdSuccess) {
      setNibrsErrorId(nibrsErrorIdResponse?.data);
    } else {
      setNibrsErrorId(null);
    }
  }, [nibrsErrorIdResponse, isNibrsErrorIdSuccess]);

  return (
    <NIBRSContext.Provider
      value={{
        incidentErrorStatus,
        setIncidentErrorStatus,
        incidentValidateNibrsData,
        offenseErrorStatus,
        setOffenseErrorStatus,
        offenseValidateNibrsData,
        nameErrorStatus,
        setNameErrorStatus,
        victimValidateNibrsData,
        offenderValidateNibrsData,
        NameRelationshipError,
        setNameRelationshipError,
        narrativeApprovedStatus,
        setNarrativeApprovedStatus,
        PropErrorStatus,
        setPropErrorStatus,
        propertyValidateNibrsData,
        nibrsSideBarLoading,
        setNibrsSideBarLoading,
        nibrsNameValidateArray,
        setNibrsNameValidateArray,
        vehErrorStatus,
        setVehErrorStatus,
        validate_IncSideBar,
        // NEW NIBRS LOGIC
        nibrsErrorId,
        refetchNibrsErrorId
      }}
    >
      {children}
    </NIBRSContext.Provider>
  );
};

export const useNIBRS = () => {
  const context = useContext(NIBRSContext);
  if (!context) throw new Error('useNIBRS must be used within NIBRSProvider');
  return context;
};

export default NIBRSContext;
